<template lang="pug">
  v-app
    v-content
      v-container
        v-layout(justify-center row fill-height)
          v-flex(xs12 sm8 md7 lg6 xl4)
            .block-auth
              LoginOrganisation(v-if="showAuthForm === ''")
              LoginPersonal(v-if="showAuthForm === 'give-me-personal-inn'")
              PinCode(v-if="showAuthForm === 'give-me-pin'")
              v-btn(
                large
                round,
                v-if="$store.state.auth.isShowBackBtn",
                @click="goBack").hidden-xs-only
                v-icon.mr-2 arrow_back
                span Назад
</template>

<script>
import LoginPersonal from '../../components/AuthPages/LoginPersonal'
import LoginOrganisation from '../../components/AuthPages/LoginOrganisation'
import PinCode from '../../components/AuthPages/Pincode'
export default {
  name: 'Auth',
  components: { PinCode, LoginOrganisation, LoginPersonal },
  computed: {
    showAuthForm() {
      return this.$store.state.auth.isVisibleAuthForm
    }
  },
  methods: {
    goBack() {
      this.$store.state.auth.isVisibleAuthForm = ''
      this.$store.dispatch('SHOW_BACK_BTN', false)
    }
  }
}
</script>

<style lang="scss" scoped>
.block-auth {
  margin-top: 100px;
  .v-btn {
    color: #007bff !important;
    position: absolute;
    top: 30px;
    left: 30px;
  }
}
@media only screen and (max-width: 600px) {
  .block-auth {
    margin-top: 70px;
  }
}
</style>



// WEBPACK FOOTER //
// src/layouts/Auth/index.vue